/**
 * Published event for user authentication
 * Fires on every portal launch after session info is loaded
 */

export enum RbcAuthEventName {
  common_auth = "common_auth",
}

export interface CommonAuthEvent {
  name: RbcAuthEventName.common_auth;
  properties: {
    /** RBC account name (e.g., "Avion", "Ion+") */
    accountName?: string;
    /** RBC user tier (e.g., "elite", "premium", "select") */
    tier?: string;
    /** RBC user province code (e.g., "ON", "QC") */
    user_province?: string;
  };
}
